<template>
  <single-panel-page class="event-page">
    <div class="alert-default">
      <p>Please fill in a passcode</p>
    </div>

    <div v-show="hasErrors" class="alert alert-danger alert-nobg text-left">
      Wrong passcode
    </div>

    <form>
      <input
        v-model="passcode"
        class="form-control passcode-field"
        autofocus
        @keydown.enter="submit()"
      />

      <br />

      <button
        class="btn btn-primary"
        :class="{ 'animated pulse': clicked }"
        :disabled="inProgress"
        type="submit"
        @click="submit()"
      >
        <loader v-show="inProgress" class="sm" />
        Submit
      </button>
    </form>

    <div slot="bottom">
      <span class="splash-box-footer">
        <router-link :to="{ name: 'eventPage', slug: slug }" href=""
          >I do not have a passcode</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import delayRequest from 'utils/delay-request'

export default {
  data: function () {
    return {
      passcode: '',
      inProgress: false,
      clicked: false,
      errors: { detail: [] },
    }
  },
  computed: {
    slug() {
      return this.$router.currentRoute.params.slug
    },
    hasErrors() {
      return this.errors.detail.length > 0
    },
  },
  created() {
    const self = this
    // self.passcode = self.$route.query.passcode || ''
    const providedPasscode = self.$route.query.passcode
    if (providedPasscode) {
      let count = 0
      const intervalId = setInterval(function () {
        if (self.passcode === providedPasscode) {
          clearInterval(intervalId) // deregisters interval
          self.submit()
        } else {
          count += 1
          self.passcode = providedPasscode.substring(0, count)
        }
      }, 50)
    }
  },
  methods: {
    submit() {
      const self = this
      self.clicked = true
      self.inProgress = true

      const eventSlug = self.$router.currentRoute.params.slug
      let request
      if (self.$route.query.user_id) {
        request = Auth.useMagicLink(self.$route.query.user_id, self.passcode)
      } else {
        request = Auth.obtainAuthTokenWithPasscode(eventSlug, self.passcode)
      }
      request = delayRequest(request, 1000)
      request
        .then((res) => {
          self.inProgress = false
          self.$store.dispatch('user/fetch')
          self.$router.push({ name: 'dashboardStartupList' })
        })
        .catch((res) => {
          console.log(
            ' => errors while trying to obtain auth token with passcode',
            res,
          )
        })
    },
  },
}
</script>

<style lang="scss">
.event-page {
  .passcode-field {
    text-transform: uppercase;
    font-size: 22px;
    text-align: center;
  }
}
</style>
